module.exports = parcelRequire.resolve("ecV3l");